export default __webpack_public_path__ + "static/media/ananda.3c117dc0.svg";